<div class="card-block card--box__block">
    <div class="row">
        <!--search filters-->
        <div class="col-xs-7">
            <div class="sprite card--box__search">
                <!--user search custom results-->
                <ng-template #searchList let-model="item" let-index="index">
                    {{ model.name }}
                </ng-template>
                <!--user search input (reserved for later ticket)-->
                <input [(ngModel)]="searchInfo.keyword" class="form-control card--box__search__input"
                    placeholder="{{ 'Search by name' | translate }}" (keyup.enter)="searchData.emit()" />
            </div>
        </div>
        <div class="offset-xs-1 col-xs-2" >
            <select *ngIf="showLanguage" class="form-control" (change)="changeLanguage.emit($event.target.value)">
                <option *ngFor="let language of languages; let first = first"
                        [selected]="language['locale'] === itemLanguage"
                        [value]="language['locale']">
                    {{ language.name | translate }}
                </option>
            </select>
        </div>
        <div class="col-xs-2">
            <button type="button" (click)="searchData.emit()" class="btn btn-primary btn-block ">
            <i class="fas fa-search"></i>
            {{ 'Search' | translate }}
            </button>
        </div>
    </div>
</div>